// import User from "../business/Order";
import { IFleetRepository } from "../business/IFleetRepository";
import ApiService from "../../core/presentation/services/ApiService";
import { injectable } from "inversify-sugar";
import { TQMSVehicleInterface, VehicleCategory, VehicleInfo } from "fleet/business/Fleet";
// import { filter } from "lodash";
import { DriversForVehicleApiResponse } from "fleet/presentation/store/types";
import { getUnassignedDriverThunk } from "../presentation/store/fleetSlice";

@injectable()
class FleetRepository implements IFleetRepository {
  public async getAllVechiles(page: number, input: string, filter: string, report: string, limit?: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/vehicle?page=${page}&limit=${limit}${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}${report}` : `/vehicle${filter ? `?${filter}` : ""}${report}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllVehiclesOfDriver(driverId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/get-vehicle/${driverId}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAVehicle(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteVehicle(id: number): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`/vehicle/${id}`, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createVehicleCategory(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/vehicle-categories", values);
      return response.data;
    } catch (error) {
      //   return error;
      Promise.reject(error);
    }
  }

  public async transferOwnership(values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("/vehicle/transfer-ownership", values);
      return response.data;
    } catch (error) {
      //   return error;
      Promise.reject(error);
    }
  }

  public async getAllVehicleCategory(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/vehicle/vehicle-categories?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/vehicle/vehicle-categories${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteVehicleCategory(id: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`/vehicle/vehicle-category/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehicleCategory(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/vehicle-category/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateVehicleCategory(id: any, value: VehicleCategory): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/vehicle/vehicle-category/${id}`, value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async changeVehicleOwn(id: any, value: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/trip/vehicle-shift/${id}`, value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async changeVehicleRequestStatus(id: any, value: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/trip/vehicle-change-request/${id}`, value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async checkVehicleExistance(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/filter", value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllChangeRequests(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/trip/vehicle-change-request?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/trip/vehicle-change-request${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async changeVehicleOthers(id: any, value: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/trip/vehicle-change/${id}`, value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getUnits(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/vehicle/units", "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createUnit(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/unit", value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createVehicleTypes(value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/vehicle-types", value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateVehicleTypes(id: number, value: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/vehicle/vehicle-types/${id}`, value);
      return response?.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAllVehicleTypes(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/vehicle/vehicle-types?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/vehicle/vehicle-types${filter ? `?${filter}` : ""}`, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteVehicleType(id: number): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`/vehicle/vehicle-type/${id}`, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehicleType(id: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/vehicle-type/${id}`, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public getAllVehicleOwnerList = async () => {
    try {
      const response: any = await ApiService.getPost("device/vehicle-owner", "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public getTripCoordinatesById = async (id: number): Promise<any> => {
    try {
      const response: any = await ApiService.getPost("/trip/coords/" + id, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public getAllVehiclePlateColors = async (): Promise<any> => {
    try {
      const response: any = await ApiService.getPost("/vehicle/plate-colors", "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public getVehiclePolicyTypes = async (): Promise<any> => {
    try {
      const response: any = await ApiService.getPost("/vehicle/policy-types", "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public createVehicle = async (values: any): Promise<any> => {
    try {
      const response: any = await ApiService.setPost("vehicle", values);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public async updateVehicle(id: any, value: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/vehicle/${id}`, value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async createTrip(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/trip", values);
      return response.data;
    } catch (error) {
      //   return error;
      Promise.reject(error);
    }
  }

  public async getAllTrip(page: number, input: string, filter: string, ongoing: string, createdOnly?: boolean, tripDate?: string): Promise<any> {
    try {
      // Ensure the tripStatus filter is always included if createdOnly is true
      let createdFilter = createdOnly ? `/tripStatus=created` : "";
      if (tripDate) {
        const [year, month] = tripDate.split("-");
        createdFilter += `&tripDate=${year}-${month}`;
      }

      // Merge filters appropriately
      const appliedFilter = [filter, createdFilter].filter(Boolean).join("&");

      // Construct the URL based on the page parameter
      const baseUrl = page > 0 ? `/trip/v2?page=${page}&limit=10${input ? `&search=${input}` : ""}${appliedFilter ? `&${appliedFilter}` : ""}${ongoing}` : `/trip/v2${appliedFilter ? `?${appliedFilter}` : ""}${ongoing}`;

      // Make the API call
      const response: any = await ApiService.getPost(baseUrl, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAllCompletedTrips(page: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(
        page > 0
          ? `/trip/completed-trip?page=${page}&limit=10
            `
          : `/trip/completed-trip`,
        "",
      );
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async deleteTrip(id: any): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`/trip/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getATrip(id: any, showMap: boolean): Promise<any> {
    try {
      const queryParams = showMap ? "?vehicleLocation=true" : "";
      const response: any = await ApiService.getPost(`/trip/${id}${queryParams}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateTripStatus(id: any, value: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/trip/status/${id}`, {
        tripStatus: value,
      });
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async updateTrip(id: any, value: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/trip/${id}`, value);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAvailableVehicleForBidding(id: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/bid-vehicles/" + id, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getNewBids(page: number, input?: string, filter?: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(
        page > 0
          ? //   ? `order/bid-request/new?page=${page}&limit=10&search=${input}`
            //   : "order/bid-request/new",
            `/order/bid-request/new?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}`
          : `order/bid-request/new${filter ? `?${filter}` : ""}`,
        "",
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async newBidRequest(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("order/bid-request", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getRejectedBids(page: number, input: string, filter?: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(
        page > 0
          ? // `order/bid-request/rejected?page=${page}&limit=10&search=${input}`,
            `/order/bid-request/rejected?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}`
          : `order/bid-request/rejected${filter ? `?${filter}` : ""}`,
        "",
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAcceptedBids(page: number, input?: string, filter?: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/order/bid-request/accepted?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `order/bid-request/accepted${filter ? `?${filter}` : ""}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async acknowledgeDigitalContract(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("order/digital-contract-acknowledgement", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async acknowledgeContract(id: number): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`order/contract-acknowledge/v2/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async cancelBidRequest(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("order/bid-request/cancel", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async cancelOrder(values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("order/paid-bid/cancel", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //payment
  public async userPayment(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("payment/v3", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async transactionPayment(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("payment/v2", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAllVehicles(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/vehicle/vehicle-locations", "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  public async getVehicleCheckList(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/vehicle/vehicle-checklist-report?page=${page}&limit=10&search=${input}${filter}` : "/vehicle/vehicle-checklist-report", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehicleLogHistory(page: number, input: string, filter: string): Promise<any> {
    try {
      let queryParams = `page=${page}&limit=10`;
      if (input) {
        queryParams += `&search=${input}`;
      }
      if (filter) {
        queryParams += `&${filter}`;
      }
      const response: any = await ApiService.getPost(`/vehicle/vehicle-log-history/v2?${queryParams}`, "");

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getDeclinedVehicleReport(page: number, input: string, filter: string): Promise<any> {
    try {
      let url = `/vehicle/tqms?status=declined&status=rejected&type=vehicle`;

      if (page > 0) {
        url += `&page=${page}&limit=10`;
      }
      if (input) {
        url += `&search=${input}`;
      }
      if (filter) {
        url += `&${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getRejectedVehicleReport(page: number, input: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/vehicle/tqms?status=rejected&type=vehicle&page=${page}&limit=10&search=${input}&searchFrom=report` : "/vehicle/tqms?status=rejected&type=vehicle", "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getEditRequestVehicleReport(page: number, input: string, filter: string): Promise<any> {
    let url = `/vehicle/tqms?status=edit-request&type=vehicle`;

    if (page > 0) {
      url += `&page=${page}&limit=10`;
      if (input) {
        url += `&search=${input}`;
      }
      if (filter) {
        url += `&${filter}`;
      }
    }

    try {
      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAwaitingApprovalVehicleReport(page: number, input: string, filter: string): Promise<any> {
    try {
      let url = `/vehicle/tqms?status=pending&type=vehicle`;

      if (page > 0) {
        url += `&page=${page}&limit=10`;
      }
      if (input) {
        url += `&search=${input}`;
      }
      if (filter) {
        url += `&${filter}`;
      }

      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getTQMSPendingVehicles(page: number, input: string, filter: string): Promise<any> {
    try {
      const queryParams = [`status=pending`, `page=${page}`, `limit=10`, filter && filter, input && `search=${input}`].filter(Boolean).join("&");
      const url = page > 0 ? `/vehicle?${queryParams}` : `/vehicle?status=pending`;
      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getLoadBoardPendingVehicles(page: number, input: string, filter: string): Promise<any> {
    try {
      const queryParams = [`adminApproval=false`, `page=${page}`, `limit=10`, filter && filter, input && `search=${input}`].filter(Boolean).join("&");
      const url = page > 0 ? `/vehicle?${queryParams}` : `/vehicle?adminApproval=false`;
      const response: any = await ApiService.getPost(url, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getAwaitingApprovalDriverReport(type: string, page: number, input: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/users/tqms-user?type=${type}&status=pending&page=${page}&limit=10&search=${input}` : "/users/tqms-user", "");

      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async getStatusDriverReport(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/users/tqms-user", values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async getStatusVehicleReport(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/vehicle/tqms-fleet`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  //insurance company
  public async getInsuranceCompany(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/vehicle/insurance-company", "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async checkUniqueVehicleNumber(vehicleNumber: string): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/unique-vehicle-number", {
        vehicleNumber,
      });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getUnassignedDriver(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/vehicle/unassign-driver", "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAllDriversOfVehicle(vehicleId: number): Promise<DriversForVehicleApiResponse> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/get-driver/${vehicleId}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async assignDriver(values: any): Promise<VehicleInfo> {
    try {
      const response: any = await ApiService.setPost("/vehicle/assign-driver", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateVehicleStatus(id: number, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("/vehicle/vehicle-status/" + id, values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getOrderBidDetails(id: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost("order/bid-request/" + id, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //for getting onboarding data of vehicle, driver and vehicle owner
  public async getOnboardingData(status: string, type: string, page: number, input: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/users/tqms-user?status=${status}&type=${type}&page=${page}&limit=10&search=${input}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //For getting the
  public async getVehicleOnBoardingLists(page: number, input: string, filter: string, status?: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(
        // `/vehicle/tqms/vehicle-lists?page=${page}&limit=10&search=${input}`,

        // `/vehicle/tqms/vehicle-lists`,
        page > 0 ? `/vehicle?page=${page}&limit=10&status=${status}${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/vehicle${filter ? `?${filter}` : ""}`,

        "",
      );
      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async setVehicleEditOnBoarding(id: number, value: string): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/vehicle/tqms-fleet/edit/${id}`, value);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getVehicleDetailsById(value: { vehicleId: number }): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/vehicle/filter`, value);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //sthaniyay
  public async getSthaniya(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/vehicle/sthaniya", "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getProformaInvoice(id: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`payment/proforma-invoice/${id}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getTQMSVehicleDetails(id: number): Promise<TQMSVehicleInterface> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/tqms-vehicle/${id}`, "");
      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPendingVehicleDetails(id: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(
        `/vehicle/tqms/vehicle/${id}`,

        "",
      );

      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //For getting the pending approval vehicles
  public async getPendingApprovalVehicles(page: number, input: string, filter: string, status: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(
        page > 0 ? `/vehicle?page=${page}&limit=10&status=${status}${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/vehicle${filter ? `?${filter}` : ""}`,

        "",
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async acceptrejectvehicle(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/vehicle-approval", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getTripActualPath(id: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/trip/trip-route/" + id, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAVehicleChangeRequestById(id: any): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/trip/vehicle-change-request/${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVirtualCheckpoints(page: number, input: string, filter: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/vehicle/virtual-checkpoint?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/vehicle/virtual-checkpoint${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }
  public async getPaymentDetails(id: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`payment/creditor/validation?TXNID=${id}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getNepalPayDetails(validationTraceId: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`payment/creditor/validation?validationTraceId=${validationTraceId}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehiclePlanTrend(page: number, input: string, filter: string, vehicleId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/subscription/vehicle-trend/${vehicleId}?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/subscription/vehicle-trend/${vehicleId}${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async getVehicleScheduledPlan(page: number, input: string, filter: string, vehicleId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/subscription/schedule-plan-update/${vehicleId}?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}` : `/subscription/schedule-plan-update/${vehicleId}${filter ? `?${filter}` : ""}`, "");
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // Add getCancelledPlan implementation
  public async getCancelledPlan(vehicleId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/subscription/refund-request/${vehicleId}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //Contract Vehicle
  public async updateContractVehicle(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/vehicle/contract-vehicle/${id}`, values);
      return response;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public getVehicleContractHistory = async (vehicleId: number): Promise<any> => {
    try {
      const response: any = await ApiService.getPost("/vehicle/contract-history/" + vehicleId, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  };

  public async getCancelledBids(page: number, input: string, filter?: string): Promise<any> {
    try {
      const response: any = await ApiService.getPost(page > 0 ? `/order/bid-request/rejected?page=${page}&limit=10${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}&status=canceled_by_shipper,canceled_by_vehicle_owner` : `/order/bid-request/rejected?status=canceled_by_shipper,canceled_by_vehicle_owner${filter ? `&${filter}` : ""}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async deleteVirtualCheckpoint(id: number): Promise<any> {
    try {
      const response: any = await ApiService.deletePost(`/vehicle/virtual-checkpoint/${id}`, "");
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async createVirtualCheckpoint(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/vehicle/virtual-checkpoint", values);
      return response.data;
    } catch (error) {
      //   return error;
      Promise.reject(error);
    }
  }

  public async updateVirtualCheckpoint(id: any, values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/vehicle/virtual-checkpoint/${id}`, values);
      return response.data;
    } catch (error) {
      Promise.reject(error);
    }
  }

  // Add cancelSubscription implementation
  public async cancelSubscription(vehicleId: number, data: { documentId?: number; additionalDetails?: string }): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/subscription/cancel-subscription/${vehicleId}`, data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getApplicableCancellationPolicy(vehicleId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/subscription/applicable-policy/${vehicleId}`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Subscription expiry reminder
  public async getSubscriptionExpiryReminders(): Promise<any> {
    try {
      const response: any = await ApiService.getPost("/subscription/expiry-reminder", "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateSubscriptionExpiryReminder(reminderId: number, data: { remindBeforeDays: number }): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/subscription/expiry-reminder/${reminderId}`, data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updatePlan(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost("/subscription/payment/v2", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updatePaymentStatus(values: any): Promise<any> {
    try {
      const response: any = await ApiService.updatePost("/subscription/payment-status", values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async verifyPromoCode(values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/promotion/validate-promo-code`, values);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getApplicablePromoCode(page: number, limit?: number, search?: string, filter?: string): Promise<any> {
    try {
      let url = `/promotion/applicable-promo-codes?page=${page}&limit=${limit ?? 10}`;
      if (search) url += `&search=${search}`;
      if (filter) url += `&${filter}`;
      const response: any = await ApiService.getPost(url, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAppliedPromoCode(page: number, limit?: number, search?: string, filter?: string): Promise<any> {
    try {
      let url = `/promotion/applied-promo-codes?page=${page}&limit=${limit ?? 10}`;
      if (search) url += `&search=${search}`;
      if (filter) url += `&${filter}`;
      const response: any = await ApiService.getPost(url, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getLiveShipmentTrack(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/trip/shipment-track`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getPaymentLogs(values: any): Promise<any> {
    try {
      // const response: any = await ApiService.getPost(
      //   `/payment/transaction-log`,
      //   values
      // );
      const { page, input, filter, activeTab } = values;
      const response: any = await ApiService.getPost(`/payment/payment-log?table=${activeTab}${!!page ? `&page=${page}&limit=10` : ""}${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}`, "");

      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getCommissionReport(values: any): Promise<any> {
    try {
      // const response: any = await ApiService.getPost(
      //   `/payment/transaction-log`,
      //   values
      // );
      const { page, input, filter, paymentPartner } = values;
      const response: any = await ApiService.getPost(`/payment/commission-report?paymentPartner=${paymentPartner}${!!page ? `&page=${page}&limit=10` : ""}${input ? `&search=${input}` : ""}${filter ? `&${filter}` : ""}`, "");

      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getUnassignedDriverV2(vehicleId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/get-driver/${vehicleId}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getUnassignedVehicleV2(driverId: number): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/get-vehicle/${driverId}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getSearchVehicle(query: string): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/vehicle/partial-search`, { search: query });
      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async vehicleAction(vehicleId: number, values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/vehicle/vehicle-action/${vehicleId}`, values);
      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async shiftVehicleOwnerThunk(vehicleId: number, values: any): Promise<any> {
    try {
      const response: any = await ApiService.setPost(`/vehicle/shift-owner/${vehicleId}`, values);
      return response?.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async getAllVehicleStatus(): Promise<any> {
    try {
      const response: any = await ApiService.getPost(`/vehicle/eligible-vehicle-status`, "");
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updateEligibleVehicleStatus(vehicleStatusId: number): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/vehicle/eligible-vehicle-status/${vehicleStatusId}`, "");
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async updatePlanFeatures(planId: number, featureIds: number[]): Promise<any> {
    try {
      const response: any = await ApiService.updatePost(`/subscription/plan-feature/${planId}`, { featureIds });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default FleetRepository;
